module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.buttonShow('create')) ? _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.createModalDialog = true
      }
    }
  }, [_vm._v("Create new")]) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Creator Statistics Report\n          ")], 1)]
      }
    }], null, false, 2965343245)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('details', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Cost & Period Report\n          ")], 1)]
      }
    }], null, false, 3859430940)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('all', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Creator Payout Report\n          ")], 1)]
      }
    }], null, false, 1434504238)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('pairings', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole && !_vm.isArchive) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "dense": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Campaign Performance Report\n          ")], 1)]
      }
    }], null, false, 435468050)
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'excel')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Excel")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'csv')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("CSV")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.openReportPasscodeDialog('performance', 'sync')
      }
    }
  }, [_c('v-list-item-title', [_vm._v("Sync Data")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.paginate(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat"
  })]), _vm._v(" "), (_vm.buttonShow('create')) ? _c('v-btn', {
    staticClass: "ml-2",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset Filters")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [(_vm.isNotClientRole) ? _c('v-row', {
    staticClass: "filter-area"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignTypeDisplayFilter,
      "item-value": "value",
      "item-text": "text",
      "label": "Type",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.campaignType),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "campaignType", $$v)
      },
      expression: "selectedFilter.campaignType"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignVerticals,
      "item-value": "id",
      "item-text": "name",
      "label": "Campaign Verticals",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.vertical),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "vertical", $$v)
      },
      expression: "selectedFilter.vertical"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.countries,
      "item-value": "code",
      "item-text": "name",
      "label": "Target Location",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.targetLocation),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "targetLocation", $$v)
      },
      expression: "selectedFilter.targetLocation"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.AM,
      "item-value": "id",
      "item-text": "name",
      "label": "AM",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.AM),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "AM", $$v)
      },
      expression: "selectedFilter.AM"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.CO,
      "item-value": "id",
      "item-text": "name",
      "label": "CC",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.CO),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "CO", $$v)
      },
      expression: "selectedFilter.CO"
    }
  })], 1), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.campaignStageDisplay,
      "label": "Stage",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.stage),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "stage", $$v)
      },
      expression: "selectedFilter.stage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "1",
      "lg": "1"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.verifiedFilters,
      "label": "Verified Payouts",
      "hide-details": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedFilter.verified),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "verified", $$v)
      },
      expression: "selectedFilter.verified"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-row', [(_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "startMonthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedStartMonth,
      "transition": "scale-transition",
      "offset-y": "",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedStartMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedStartMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "Start Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.selectedFilter.searchStartMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "searchStartMonth", $$v)
            },
            expression: "selectedFilter.searchStartMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 625897265),
    model: {
      value: (_vm.startMonthPicker),
      callback: function($$v) {
        _vm.startMonthPicker = $$v
      },
      expression: "startMonthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.searchStartMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "searchStartMonth", $$v)
      },
      expression: "selectedFilter.searchStartMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.startMonthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchStartMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.campaignStatus === -1) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-menu', {
    ref: "endMonthPicker",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.selectedEndMonth,
      "transition": "scale-transition",
      "dense": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function($event) {
        _vm.selectedEndMonth = $event
      },
      "update:return-value": function($event) {
        _vm.selectedEndMonth = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": "End Month",
            "readonly": "",
            "clearable": "",
            "outlined": "",
            "dense": "",
            "hide-details": "auto"
          },
          on: {
            "change": _vm.searchFilter
          },
          model: {
            value: (_vm.selectedFilter.searchLastMonth),
            callback: function($$v) {
              _vm.$set(_vm.selectedFilter, "searchLastMonth", $$v)
            },
            expression: "selectedFilter.searchLastMonth"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }], null, false, 3717502516),
    model: {
      value: (_vm.endMonthPicker),
      callback: function($$v) {
        _vm.endMonthPicker = $$v
      },
      expression: "endMonthPicker"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "type": "month",
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.selectedFilter.searchLastMonth),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "searchLastMonth", $$v)
      },
      expression: "selectedFilter.searchLastMonth"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.endMonthPicker = false
      }
    }
  }, [_vm._v("\n                    Cancel\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": _vm.searchEndMonthOk
    }
  }, [_vm._v("\n                    OK\n                ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-checkbox', {
    staticClass: "filter-checkbox mt-1",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "label": "HTML Reports",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.searchFilter()
      }
    },
    model: {
      value: (_vm.selectedFilter.htmlReport),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "htmlReport", $$v)
      },
      expression: "selectedFilter.htmlReport"
    }
  })], 1), _vm._v(" "), (!_vm.isArchive) ? _c('v-col', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "2",
      "lg": "2"
    }
  }, [_c('v-checkbox', {
    staticClass: "filter-checkbox mt-1",
    staticStyle: {
      "max-width": "150px"
    },
    attrs: {
      "label": "Load Archive",
      "color": "secondary",
      "value": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.selectedFilter.archive),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "archive", $$v)
      },
      expression: "selectedFilter.archive"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-row', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "justify": "end"
    }
  }, [(!_vm.isArchive) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [_c('v-toolbar', {
    staticClass: "bulk-action float-left transparent",
    attrs: {
      "flat": ""
    }
  }, [(_vm.selectedCampaigns.length > 0) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "secondary"
          }
        }, on), [_vm._v("Bulk Action")])]
      }
    }], null, false, 1812722738)
  }, [_vm._v(" "), _c('v-list', _vm._l((_vm.tableActions), function(menuItem, i) {
    return _c('v-list-item', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.performSelected(menuItem.action)
        }
      }
    }, [_c('v-list-item-content', [_c('div', [_c('v-icon', [_vm._v("mdi-" + _vm._s(menuItem.icon))]), _vm._v(" " + _vm._s(menuItem.name) + "\n                      ")], 1)])], 1)
  }), 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isArchive) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "8",
      "lg": "8"
    }
  }, [(_vm.selectedCampaigns.length > 0) ? _c('v-btn', {
    staticClass: "mt-3",
    attrs: {
      "color": "success",
      "small": ""
    },
    on: {
      "click": _vm.restoreArchive
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-restore")]), _vm._v(" Restore\n            ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "4",
      "md": "4",
      "lg": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isNotClientRole) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.isNotClientRole) ? _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "-25px"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-pressed": String(_vm.showActionsColumn),
      "title": _vm.showActionsColumn ? 'Hide Actions column' : 'Show Actions column',
      "aria-label": _vm.showActionsColumn ? 'Hide Actions column' : 'Show Actions column'
    },
    on: {
      "click": function($event) {
        _vm.showActionsColumn = !_vm.showActionsColumn
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.showActionsColumn ? 'mdi-eye-off-outline' : 'mdi-eye-outline'))])], 1)], 1), _vm._v(" "), (_vm.campaignStatus === -1 && _vm.isNotClientRole) ? _c('v-data-table', {
    staticClass: "ims-sticky-actions-table table-small elevation-1",
    class: {
      'actions-column-visible': _vm.showActionsColumn
    },
    attrs: {
      "headers": _vm.computedAllCampaignHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "show-select": "",
      "single-select": false,
      "loading": _vm.loading
    },
    on: {
      "toggle-select-all": _vm.selectAllCampaigns
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), (item.archive) ? _c('v-chip', {
          attrs: {
            "x-small": ""
          }
        }, [_vm._v("\n              Archived\n            ")]) : _c('div', [(item.lockedCOGS) ? _c('div', [_c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n                ")], 1)], 1) : _vm._e()])], 1)]
      }
    }, {
      key: "item.campaignType",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.campaignType))])]
      }
    }, {
      key: "item.countryDisplay",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.countryDisplay))])]
      }
    }, {
      key: "item.vertical",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, _vm._l((item.vertical), function(i, index) {
          return _c('v-chip', {
            key: index,
            staticClass: "ma-1",
            attrs: {
              "small": ""
            }
          }, [_vm._v("\n              " + _vm._s(i.name) + "\n            ")])
        }), 1)]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            $" + _vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n            "), (_vm.isNotClientRole && item.markupCOGS) ? _c('v-chip', {
          attrs: {
            "color": "warning",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n              Markup COGS\n            ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.target",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.target) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.target)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogs) ? _c('span', [_vm._v("\n              $" + _vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n              "), (item.cogs && item.target && item.cogs > item.target) ? _c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n                Burst COGS\n              ")]) : _vm._e()], 1) : _vm._e()])]
      }
    }, {
      key: "item.cogsPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogsPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsPercentage) + "%")]) : _vm._e()])]
      }
    }, {
      key: "item.campaignPeriod",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.campaignPeriod || ''))])]
      }
    }, {
      key: "item.startMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.startMonth ? _vm.formatMonth(item.startMonth) : ''))])]
      }
    }, {
      key: "item.endMonth",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.endMonth ? _vm.formatMonth(item.endMonth) : ''))])]
      }
    }, {
      key: "item.firstPostDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.firstPostDate || ''))])]
      }
    }, {
      key: "item.lastPostDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.lastPostDate || ''))])]
      }
    }, {
      key: "item.payoutStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_c('div', [(item.payoutStatus && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-chip', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "green",
            "outlined": "",
            "small": "",
            "target": "_blank",
            "to": '/finance/payment-consolidation/status?id=' + item.id
          }
        }, [_vm._v("\n                  " + _vm._s(item.payoutStatusDisplay) + "\n              ")]) : _c('v-chip', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "outlined": "",
            "small": "",
            "target": "_blank",
            "to": '/finance/payment-consolidation/status?id=' + item.id
          }
        }, [_vm._v("\n                  " + _vm._s(item.payoutStatusDisplay) + "\n                ")])], 1)])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "230px"
          }
        }, [(_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/campaign-report-internal?id=' + item.id,
            "target": "_blank",
            "color": "secondary",
            "title": "View Campaign Report Internal",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "aria-label": "View Campaign Report Internal"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-open-in-new")])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action ims-btn-third",
          attrs: {
            "to": '/reports/campaign/summary?id=' + item.id,
            "target": "_blank",
            "aria-label": "View Campaign HTML Report",
            "title": "View Campaign HTML Report",
            "data-toggle": "tooltip",
            "data-placement": "top"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-web")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "secondary",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Change Setting",
            "aria-label": "Change Setting"
          },
          on: {
            "click": function($event) {
              return _vm.changeSettings(item)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders-h"
        })]), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Campaign",
            "color": "error",
            "aria-label": "Delete Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Campaign",
            "aria-label": "Edit Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 0 || item.activated == undefined),
            expression: "item.activated == 0 || item.activated == undefined"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showAMCCInputsDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 1),
            expression: "item.activated == 1"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Deactivate Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.activateCampaign(item.id, _vm.campaignActivationStatusConfig.DEACTIVATED)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work_off")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.viewInfluencerPairingModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        }, [_vm._v("mdi-account-convert")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog secondary--text",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })]), _vm._v(" "), (_vm.buttonShowBrandSheet(item)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Brand Fact Sheet",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.openBrandSheetModalDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-file-document")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.viewPairingBriefModalIdDisplay,
            "color": "info",
            "title": "View Pairing Brief",
            "aria-label": "View Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Brief"
          }
        }, [_vm._v("pageview")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Brief",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.showConfirmPayout) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.getPairedInfluencers(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.showConfirmPayout) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/influencers/invoices-brief-confirmation?id=' + item.id,
            "target": "_blank",
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedCampaigns),
      callback: function($$v) {
        _vm.selectedCampaigns = $$v
      },
      expression: "selectedCampaigns"
    }
  }) : _c('v-data-table', {
    key: _vm.campaignDataTableKey,
    staticClass: "ims-sticky-actions-table elevation-1",
    class: {
      'actions-column-visible': _vm.showActionsColumn
    },
    attrs: {
      "headers": _vm.computedCampaignHeaders,
      "search": _vm.filter,
      "items": _vm.filteredItems,
      "show-select": _vm.isNotClientRole,
      "single-select": false
    },
    on: {
      "toggle-select-all": _vm.selectAllCampaigns
    },
    scopedSlots: _vm._u([{
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n            "), (_vm.isNotClientRole && item.lockedCOGS) ? _c('div', [_c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-lock")]), _vm._v(" Locked COGS\n              ")], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.budget",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            $" + _vm._s(_vm._f("thousandSeprator")(item.budget)) + "\n            "), (_vm.isNotClientRole && item.markupCOGS) ? _c('v-chip', {
          attrs: {
            "color": "warning",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n              Markup COGS\n            ")]) : _vm._e()], 1)]
      }
    }, {
      key: "item.target",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.target) ? _c('span', [_vm._v("$" + _vm._s(_vm._f("thousandSeprator")(item.target)))]) : _vm._e()])]
      }
    }, {
      key: "item.cogs",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogs) ? _c('span', [_vm._v("\n              $" + _vm._s(_vm._f("thousandSeprator")(item.cogs)) + "\n              "), (item.cogs && item.target && item.cogs > item.target) ? _c('v-chip', {
          attrs: {
            "color": "red",
            "x-small": "",
            "text-color": "white"
          }
        }, [_vm._v("\n                Burst COGS\n              ")]) : _vm._e()], 1) : _vm._e()])]
      }
    }, {
      key: "item.cogsPercentage",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [(item.cogsPercentage) ? _c('span', [_vm._v(_vm._s(item.cogsPercentage) + "%")]) : _vm._e()])]
      }
    }, {
      key: "item.payoutStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center"
        }, [_vm._v(_vm._s(item.payoutStatus ? _vm.payoutStatusDisplay[item.payoutStatus] : ''))])]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "justify-center"
        }, [(_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "to": '/campaign-report-internal?id=' + item.id,
            "target": "_blank",
            "color": "secondary",
            "data-placement": "top",
            "data-toggle": "tooltip",
            "title": "View Campaign Report Internal",
            "aria-label": "View Campaign Report Internal"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi mdi-open-in-new")])], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole && item.status >= _vm.campaignStatuses.ONGOING) ? _c('v-btn', {
          staticClass: "ims-action ims-btn-third",
          attrs: {
            "to": '/reports/campaign/summary?id=' + item.id,
            "target": "_blank",
            "title": "View Campaign HTML Report",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "aria-label": "View Campaign HTML Report"
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-web")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('settings')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Change Settings",
            "aria-label": "Change Settings",
            "color": "secondary"
          },
          on: {
            "click": function($event) {
              return _vm.changeSettings(item)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-sliders-h"
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('delete')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Delete Campaign",
            "aria-label": "Delete Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('edit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Campaign",
            "aria-label": "Edit Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewByClient')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "info",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true,
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Campaign",
            "aria-label": "View Campaign"
          },
          on: {
            "click": function($event) {
              return _vm.viewCampaignByClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("remove_red_eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('draftSubmit')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to CC",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.approveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('releaseToAdmin')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "disabled": item.releasedToAdmin,
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Admin",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.releaseToAdmin(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-send")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('clientApprove')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Campaign",
            "color": "success",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('activate')) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 0 || item.activated == undefined),
            expression: "item.activated == 0 || item.activated == undefined"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.showAMCCInputsDialog(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('directClient') && item.campaignType !== 'Storytell') ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Direct release to Client",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.directClient(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('activate')) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.activated == 1),
            expression: "item.activated == 1"
          }],
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Deactivate Campaign",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.activateCampaign(item.id, _vm.campaignActivationStatusConfig.DEACTIVATED)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("work_off")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewPairing')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.viewInfluencerPairingModal(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        }, [_vm._v("mdi-account-convert")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('eliminating')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "primary",
            "disabled": item.activated === _vm.campaignActivationStatusConfig.ACTIVATED ? false : true,
            "title": "View Pairing Influencers",
            "aria-label": "View Pairing Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.startEliminate(item.id)
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-users-cog secondary--text",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Influencers"
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('startCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Start Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('reviewCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Push to Review",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.pushReviewCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("mdi-progress-upload")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('closeCampaign')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Close Campaign",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("power_settings_new")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShowBrandSheet(item)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Brand Fact Sheet",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.openBrandSheetModalDialog(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-file-document")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.editPairingBriefModalIdDisplay,
            "color": "info",
            "title": "Edit Pairing Brief",
            "aria-label": "Edit Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToEdit(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Edit Pairing Brief",
            "color": "white",
            "small": ""
          }
        }, [_vm._v("rate_review")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "modal",
            "data-target": _vm.viewPairingBriefModalIdDisplay,
            "color": "info",
            "title": "View Pairing Brief",
            "aria-label": "View Pairing Brief"
          },
          on: {
            "click": function($event) {
              return _vm.getCampaignDataToView(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Pairing Brief"
          }
        }, [_vm._v("pageview")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('pairingBrief')) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Brief",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.proceedApproveCampaign(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('influencerAccept') && _vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Accept Pairing Influencer",
            "color": "success"
          },
          on: {
            "click": function($event) {
              return _vm.acceptInvite(item.pairingID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('influencerAccept') && _vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Reject Pairing Influencer",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.rejectInvite(item.pairingID)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('viewInfluencers') && !_vm.buttonShowPairing(item.pairingStatus)) ? _c('v-btn', {
          staticClass: "ims-action",
          attrs: {
            "color": "success",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "View Influencers"
          },
          on: {
            "click": function($event) {
              return _vm.getPairedInfluencers(item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("people")]), _vm._v(" "), (_vm.payoutSubmittedPairings.length > 0 && _vm.getSubmittedCount(item) > 0) ? _c('v-badge', {
          attrs: {
            "color": "error",
            "content": _vm.getSubmittedCount(item)
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "no-data",
      fn: function() {
        return [_vm._v("No Data")]
      },
      proxy: true
    }], null, true),
    model: {
      value: (_vm.selectedCampaigns),
      callback: function($$v) {
        _vm.selectedCampaigns = $$v
      },
      expression: "selectedCampaigns"
    }
  })], 1)], 1), _vm._v(" "), _c('create-campaign-modal', {
    attrs: {
      "value": _vm.createModalDialog
    },
    on: {
      "createCampaign": _vm.createCampaign
    },
    model: {
      value: (_vm.createModalDialog),
      callback: function($$v) {
        _vm.createModalDialog = $$v
      },
      expression: "createModalDialog"
    }
  }), _vm._v(" "), _c('edit-campaign-modal', {
    attrs: {
      "value": _vm.editModalDialog,
      "campaignId": _vm.editCampaignId
    },
    on: {
      "editCampaign": _vm.editCampaign
    },
    model: {
      value: (_vm.editModalDialog),
      callback: function($$v) {
        _vm.editModalDialog = $$v
      },
      expression: "editModalDialog"
    }
  }), _vm._v(" "), _c('view-campaign-modal', {
    attrs: {
      "value": _vm.viewModalDialog,
      "campaignData": _vm.viewCampaignData
    },
    model: {
      value: (_vm.viewModalDialog),
      callback: function($$v) {
        _vm.viewModalDialog = $$v
      },
      expression: "viewModalDialog"
    }
  }), _vm._v(" "), _c('edit-pairing-brief-modal', {
    attrs: {
      "modalId": _vm.editPairingBriefModalId,
      "campaignId": _vm.editCampaignId
    },
    on: {
      "editCampaign": _vm.editCampaign
    }
  }), _vm._v(" "), _c('view-pairing-brief-modal', {
    attrs: {
      "modalId": _vm.viewPairingBriefModalId,
      "campaignData": _vm.viewCampaignData
    }
  }), _vm._v(" "), _c('view-pairing-modal', {
    attrs: {
      "value": _vm.viewPairingModalDialog,
      "campaignData": _vm.viewPairingCampaignData,
      "client": _vm.campaignClient,
      "unlockCogs": _vm.isUnlockCogs
    },
    on: {
      "setUnlockCogs": _vm.setUnlockCogs
    },
    model: {
      value: (_vm.viewPairingModalDialog),
      callback: function($$v) {
        _vm.viewPairingModalDialog = $$v
      },
      expression: "viewPairingModalDialog"
    }
  }), _vm._v(" "), _c('influencer-elimination', {
    attrs: {
      "campaingData": _vm.campaingDataForElimination
    },
    model: {
      value: (_vm.eliminationDialog),
      callback: function($$v) {
        _vm.eliminationDialog = $$v
      },
      expression: "eliminationDialog"
    }
  }), _vm._v(" "), _c('view-post-modal', {
    attrs: {
      "modalId": _vm.viewPostModalId,
      "campaignData": _vm.viewPostCampaignData
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250"
    },
    model: {
      value: (_vm.viewInfluencerDialog),
      callback: function($$v) {
        _vm.viewInfluencerDialog = $$v
      },
      expression: "viewInfluencerDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Paired influencers for campaign")])]), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }], null, false, 2284781340)
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Handle")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Eng. Rate")]), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Aud. Cred")]), _vm._v(" "), (_vm.isNotClientRole) ? _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Status")]) : _vm._e(), _vm._v(" "), _c('th', {
          staticClass: "text-left"
        }, [_vm._v("Elimination Status")]), _vm._v(" "), (_vm.isNotClientRole) ? _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Payout Amount")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pairedInfluencers), function(item) {
          return _c('tr', {
            key: item.instagramHandle
          }, [_c('td', [(item.influencer_details.platform === 'tiktok') ? _c('a', {
            attrs: {
              "href": 'https://www.tiktok.com/@' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('img', {
            attrs: {
              "src": "/static/img/tiktok-32.png",
              "width": "20px"
            }
          }), _vm._v(" @" + _vm._s(item.instagramHandle))]) : (item.influencer_details.platform === 'youtube') ? _c('a', {
            attrs: {
              "href": 'https://youtube.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1) : _c('a', {
            attrs: {
              "href": 'https://instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_c('v-icon', {
            attrs: {
              "color": "#000000",
              "small": ""
            }
          }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(item.instagramHandle))], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.followers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagement_rate) + "%")]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                " + _vm._s(item.audience_credibility) + "\n              ")], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "outlined": "",
              "x-small": ""
            }
          }, [_vm._v("\n                  " + _vm._s(_vm.pairingStatusDisplay[item.pairingStatus]) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('td', [_c('v-chip', _vm._g({
            staticClass: "ma-2",
            attrs: {
              "color": _vm.eliminatinStatusColor(item.eliminationStatus),
              "x-small": "",
              "text-color": "white"
            }
          }, _vm.on), [_vm._v("\n                  " + _vm._s(_vm.eliminationStatusDisplay(item.eliminationStatus)) + "\n                  "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-check")])], 1)], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e()])
        }), 0)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1250",
      "content-class": "ims-standard-dialog"
    },
    model: {
      value: (_vm.viewInfluencerAdminDialog),
      callback: function($$v) {
        _vm.viewInfluencerAdminDialog = $$v
      },
      expression: "viewInfluencerAdminDialog"
    }
  }, [_c('v-card', {
    staticClass: "ims-modal-card"
  }, [_c('v-card-title', {
    staticClass: "title ims-modal-header"
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v("\n          Paired influencers for campaign:\n          "), _c('strong', [_vm._v(_vm._s(_vm.campaignCOEB.campaignName))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "secondary",
      "aria-label": "Close",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerAdminDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "ims-modal-body"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Contents")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm.campaignCOEB.min_content) + " to " + _vm._s(_vm.campaignCOEB.max_content))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm.measurement.total))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm.measurement.invitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm.measurement.notInvitedTotal))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.totalPercentage) + " %")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Outreach")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.outreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedOutreach)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.outreachPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Engagement")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("thousandSeprator")(_vm.campaignCOEB.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Current Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.engagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.invitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited Total: " + _vm._s(_vm._f("thousandSeprator")(_vm.measurement.notInvitedEngagement)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.engagementPercentage) + "%")])])], 1)]
      }
    }])
  })], 1), _vm._v(" "), (_vm.isNotClientRole) ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "lg": "3",
      "md": "3"
    }
  }, [_c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var hover = ref.hover;

        return [_c('v-card', {
          class: {
            'on-hover': hover
          },
          attrs: {
            "color": "#363636",
            "dark": "",
            "elevation": hover ? 12 : 2
          }
        }, [_c('v-card-title', {
          staticClass: "headline"
        }, [_vm._v("Budget")]), _vm._v(" "), _c('v-card-subtitle', [_c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Target : " + _vm._s(_vm._f("currency")(_vm.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.budget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Approved COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.invitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Not Invited COGS: " + _vm._s(_vm._f("currency")(_vm.measurement.notInvitedBudget)))]), _vm._v(" "), _c('p', {
          staticClass: "pa-0 ma-0 custom-font"
        }, [_vm._v("Percentage: " + _vm._s(_vm.measurement.cogsPercentage) + "%")])])], 1)]
      }
    }], null, false, 2284781340)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-0",
    staticStyle: {
      "justify-content": "right"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-select', {
    staticClass: "input-field pt-3",
    attrs: {
      "items": _vm.payoutStatusOptions,
      "item-value": "status",
      "item-text": "display",
      "label": "Payout Status",
      "dense": "",
      "outlined": ""
    },
    on: {
      "change": _vm.pairingSearchFilter
    },
    model: {
      value: (_vm.pairedFilter.payoutStatus),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "payoutStatus", $$v)
      },
      expression: "pairedFilter.payoutStatus"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "mdi-magnify",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.pairedFilter.search),
      callback: function($$v) {
        _vm.$set(_vm.pairedFilter, "search", $$v)
      },
      expression: "pairedFilter.search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    key: _vm.dataTableKey,
    staticClass: "elevation-1 page__table",
    attrs: {
      "headers": _vm.pairedHeaders,
      "items": _vm.pairedFilterItems,
      "items-per-page": 10,
      "search": _vm.pairedFilter.search,
      "no-data-text": 'Empty list'
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('tbody', _vm._l((props.items), function(item) {
          return _c('tr', {
            key: item.instagramHandle,
            class: {
              'yellow lighten-4': item.payoutSubmitted
            }
          }, [_c('td', [_c('social-handle', {
            attrs: {
              "divClassName": "d-inline",
              "isTikTok": item.influencer_details.platform === 'tiktok',
              "isInstagram": !item.influencer_details.platform || item.influencer_details.platform === 'instagram',
              "isYoutube": item.influencer_details.platform === 'youtube',
              "isFacebook": item.influencer_details.platform === 'facebook',
              "tiktokHandle": item.instagramHandle,
              "instagramHandle": item.instagramHandle,
              "youtubeHandle": item.instagramHandle,
              "facebookHandle": item.instagramHandle
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-center"
          }, [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.followers))])]), _vm._v(" "), _c('td', [(item.influencer_details.platform === 'facebook') ? _c('span', [_vm._v("-")]) : _c('span', [_vm._v(_vm._s(item.engagement_rate) + "%")])]), _vm._v(" "), _c('td', [_c('v-icon', {
            attrs: {
              "color": item.audience_credibility_color
            }
          }, [_vm._v("supervised_user_circle")]), _vm._v("\n                      " + _vm._s(item.audience_credibility) + "\n                    ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.deliverables))]), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', [_c('v-chip', {
            staticClass: "ma-2",
            attrs: {
              "color": _vm.payoutStatusColor(item.payoutStatus),
              "outlined": "",
              "small": ""
            }
          }, [_vm._v("\n                        " + _vm._s(_vm.payoutStatusDisplay[item.payoutStatus || 0]) + "\n                        "), _c('v-icon', {
            attrs: {
              "right": "",
              "x-small": ""
            }
          }, [_vm._v("mdi-circle-edit-outline")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isNotClientRole) ? _c('td', {
            staticClass: "text-right"
          }, [_vm._v("$ " + _vm._s(item.payoutAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
            staticClass: "text-center paired-actions-cell"
          }, [_c('div', {
            staticClass: "paired-actions"
          }, [(_vm.buttonShow('editPayout')) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "secondary",
                    "aria-label": "Edit payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.openConfirmPayoutDialog(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-pencil")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Edit payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus !== _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "primary",
                    "aria-label": "Confirm payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.updateSend(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": "",
                    "color": "secondary"
                  }
                }, [_vm._v("mdi-check")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Confirm payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonShow('editPayout') && _vm.showConfirmPayout && item.payoutStatus === _vm.payoutStatus.CONFIRMED) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "color": "error",
                    "aria-label": "Cancel payout"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.cancelPayout(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-cancel")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("Cancel payout")])]) : _vm._e(), _vm._v(" "), (_vm.buttonPayoutViewShow(item)) ? _c('v-tooltip', {
            attrs: {
              "top": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;
                var attrs = ref.attrs;

                return [_c('v-btn', _vm._g(_vm._b({
                  staticClass: "paired-action-btn ims-btn-third",
                  attrs: {
                    "icon": "",
                    "small": "",
                    "aria-label": "View payouts"
                  },
                  on: {
                    "click": function($event) {
                      return _vm.linkPayoutInternal(item)
                    }
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  }
                }, [_vm._v("mdi-eye")])], 1)]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', [_vm._v("View payouts")])]) : _vm._e()], 1)])])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "ims-modal-actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.viewInfluencerAdminDialog = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('payout-confirm-modal', {
    attrs: {
      "value": _vm.payoutConfirmDialog,
      "data": _vm.payoutConfirmData,
      "influencer": _vm.influencer
    },
    on: {
      "confirmedPayout": _vm.setConfirmedPayout
    },
    model: {
      value: (_vm.payoutConfirmDialog),
      callback: function($$v) {
        _vm.payoutConfirmDialog = $$v
      },
      expression: "payoutConfirmDialog"
    }
  }), _vm._v(" "), _c('campaign-settings', {
    attrs: {
      "campaign": _vm.viewCampaignData
    },
    on: {
      "saved": _vm.reload
    },
    model: {
      value: (_vm.campaignSettingsDialog),
      callback: function($$v) {
        _vm.campaignSettingsDialog = $$v
      },
      expression: "campaignSettingsDialog"
    }
  }), _vm._v(" "), _c('view-client-modal', {
    attrs: {
      "clientData": _vm.viewClientData
    },
    model: {
      value: (_vm.viewClientDialog),
      callback: function($$v) {
        _vm.viewClientDialog = $$v
      },
      expression: "viewClientDialog"
    }
  }), _vm._v(" "), _c('view-brand-sheet-modal', {
    attrs: {
      "value": _vm.viewBrandSheetModalDialog,
      "brandSheetData": _vm.viewbrandSheetData
    },
    model: {
      value: (_vm.viewBrandSheetModalDialog),
      callback: function($$v) {
        _vm.viewBrandSheetModalDialog = $$v
      },
      expression: "viewBrandSheetModalDialog"
    }
  }), _vm._v(" "), _c('influencer-detail-modal', {
    attrs: {
      "dialog": _vm.invoiceDialog,
      "influencer": _vm.influencer,
      "influencerProfile": _vm.influencerProfile,
      "selectedTab": _vm.selectedTab,
      "briefDetailContent": _vm.briefDetailsHTML,
      "close": _vm.closeModal,
      "newPairingFlow": true,
      "isDownload": _vm.invoiceDownload
    },
    on: {
      "loadInfluencer": _vm.loadInfluencerData,
      "reRenderDatTable": _vm.loadInfluencerData,
      "loadingDialogOpen": _vm.loadingDialogOpen,
      "loadingDialogClose": _vm.loadingDialogClose
    }
  }), _vm._v(" "), _c('change-status-modal', {
    attrs: {
      "campaign": _vm.campaignDataForStatusChange,
      "campaignIds": _vm.selectedCampaignIds
    },
    on: {
      "updated": _vm.reload
    },
    model: {
      value: (_vm.changeStatusDialog),
      callback: function($$v) {
        _vm.changeStatusDialog = $$v
      },
      expression: "changeStatusDialog"
    }
  }), _vm._v(" "), _c('all-reports-passcode-modal', {
    attrs: {
      "value": _vm.allReportsPasscodeDialog,
      "reportType": _vm.downloadReportType
    },
    on: {
      "success": _vm.reportPasscodeSuccess
    },
    model: {
      value: (_vm.allReportsPasscodeDialog),
      callback: function($$v) {
        _vm.allReportsPasscodeDialog = $$v
      },
      expression: "allReportsPasscodeDialog"
    }
  }), _vm._v(" "), _c('release-to-cc-modal', {
    attrs: {
      "campaign": _vm.campaignDataForSubmitDraft
    },
    on: {
      "saved": _vm.proceedApproveCampaign
    },
    model: {
      value: (_vm.releaseToCCDialog),
      callback: function($$v) {
        _vm.releaseToCCDialog = $$v
      },
      expression: "releaseToCCDialog"
    }
  }), _vm._v(" "), _c('release-to-admin-modal', {
    attrs: {
      "campaign": _vm.campaignDataForAccept
    },
    on: {
      "saved": _vm.proceedReleaseToAdmin
    },
    model: {
      value: (_vm.releaseToAdminDialog),
      callback: function($$v) {
        _vm.releaseToAdminDialog = $$v
      },
      expression: "releaseToAdminDialog"
    }
  }), _vm._v(" "), _c('am-cc-inputs-modal', {
    attrs: {
      "campaign": _vm.campaignDataForRelease,
      "source": "release"
    },
    on: {
      "proceedBrief": _vm.showCheckListDialog
    },
    model: {
      value: (_vm.amCCInputsDialog),
      callback: function($$v) {
        _vm.amCCInputsDialog = $$v
      },
      expression: "amCCInputsDialog"
    }
  }), _vm._v(" "), _c('brief-release-checklist-modal', {
    attrs: {
      "campaign": _vm.campaignDataForRelease
    },
    on: {
      "confirmActivate": _vm.proceedActivateCampaign
    },
    model: {
      value: (_vm.briefReleaseChecklistDialog),
      callback: function($$v) {
        _vm.briefReleaseChecklistDialog = $$v
      },
      expression: "briefReleaseChecklistDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Masterlist",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), _c('invoices-brief-view-modal', {
    attrs: {
      "campaignID": _vm.viewCampaignId,
      "value": _vm.invoicesBriefViewDialog
    },
    on: {
      "reload": _vm.reload
    },
    model: {
      value: (_vm.invoicesBriefViewDialog),
      callback: function($$v) {
        _vm.invoicesBriefViewDialog = $$v
      },
      expression: "invoicesBriefViewDialog"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "300"
    },
    model: {
      value: (_vm.loadingDialog),
      callback: function($$v) {
        _vm.loadingDialog = $$v
      },
      expression: "loadingDialog"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f87416"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/index.vue
// module id = 2011
// module chunks = 0